import { PolylineEditDataCommand } from "lib/commands/edition/polyline";
import { setPosBuffer } from "lib/geometries";
import { IPolylineParam, getBufferFromPolylineParam, movePolyArcEdge } from "lib/math/line";
import { IPoint } from "lib/math/types";
import { LineData } from "lib/models/primitives/line";
import { SimpleEdition } from "../edition";
import { cadOpType } from "../factory";
import { settingsOpModes } from "../step-operations";

export class MovePolyLineEdgeOP extends SimpleEdition {
  public opType = cadOpType.EDITPOLYLINEEDGE;

  protected objData: LineData;
  protected auxDefinition: IPolylineParam;
  protected indexToEdit: number;

  constructor(data: LineData, indexToEdit: number, iniPoint: IPoint) {
    super(iniPoint);
    this.indexToEdit = indexToEdit;
    this.objData = data;
    this.auxDefinition = this.objData.cloneDefinition();
    this.auxPoly = this.objData.createObject(this.auxDefinition);
  }
  protected iniSettingsOp() {
    this.settingsOpManager.setCfg([{
      infoMsg: "Edit point: ",
      stepMode: settingsOpModes.DEFAULTXYZ,
      cmdLineListener: this.addPointFromExt.bind(this),
    }]);
  }
  public setLastPoint() {
    this.endOperation();
  }
  public moveLastPoint(point: IPoint) {
    this.auxDefinition = this.objData.cloneDefinition();
    movePolyArcEdge(this.auxDefinition, point, this.indexToEdit);
    const buff = getBufferFromPolylineParam(this.auxDefinition);
    setPosBuffer(this.auxPoly, buff);
  }
  public save() {
    const command = new PolylineEditDataCommand(this.objData, this.auxDefinition, null, this.graphicProcessor);
    this.graphicProcessor.storeAndExecute(command);
  }
}
